import topbar from 'topbar'

export function show() {
  topbar.show(300)
}

export function hide() {
  topbar.hide()
}
